import { render, staticRenderFns } from "./RunnerStartsColMobile.vue?vue&type=template&id=06c2b4d2&scoped=true&"
import script from "./RunnerStartsColMobile.vue?vue&type=script&lang=js&"
export * from "./RunnerStartsColMobile.vue?vue&type=script&lang=js&"
import style0 from "./RunnerStartsColMobile.vue?vue&type=style&index=0&id=06c2b4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2b4d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
